import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import queryString  from 'query-string';

// componentes
import { Card, Col, Row } from 'react-bootstrap';
import Carregador from './../../Componentes/Carregador';
import PaginacaoComponente from './../../Componentes/Paginacao';
// import Parametros from './Parametros';
import Registro from './Registro';

export default function Consultar(){

    // estados
    const history = useHistory();
    const { cartaOferta } = useParams();
    const location = useLocation();
    console.log(cartaOferta);
    let [parametros, alterarParametros] = useState(Object.assign({
        
    }, queryString.parse(location.search, {arrayFormat: 'bracket'})));
    let [totalRegistros, atualizarTotalRegistros] = useState(0);
    let [carregando, mostrarCarregando] = useState(false);
    let [consulta, alterarConsulta] = useState([]);

    // inicializa
    useEffect(() => {
        consultarRegistros();
    }, [parametros]);

    async function consultarRegistros(){
        mostrarCarregando(true);

        try {

            // faz a requisição
            let { data } = await axios.get(`/formularioAcidentesPessoais/agrupado`, { params: parametros });
            alterarConsulta(data.registros);
            atualizarTotalRegistros(parseInt(data.totalRegistros));

        }catch({response}){}
        finally{
            mostrarCarregando(false);
        }

    }

     // testar
     async function clicouVer(cartaOferta){
        let parametros = { cartaOferta: cartaOferta };
        let encodeQuery = queryString.stringify(parametros, {arrayFormat: 'bracket'});

        // atualizar url
        history.push({
            pathname: '/painel/proposta-formularios',
            search: "?"+encodeQuery
        });
    }


    return <>
        <Row>
            <Col>
                <Card className="painel-consulta border-0 shadow-sm" >
                    <div className="card-header position-relative">
                        <h4 className="card-title font-weight-bolder">Propostas</h4>
                        {/* <p className="card-category">Here is a subtitle for this table</p> */}

                        {/* <Parametros parametros={parametros} alterarParametros={alterarParametros} /> */}
                    </div>
                    
                    <Card.Body>
                        
                        <table className="table table-hover tabela">
                            <thead>
                                <tr>
                                    <th>Quantidade</th>
                                    <th>Não Lidos</th>
                                    <th>Carta Oferta</th>
                                    <th>Empresa</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {consulta.map((registro, a) => 
                                    <Registro 
                                        key={a} 
                                        dados={registro.dados}
                                        parametros={parametros}
                                        onClickTr={() => console.log('clicou TR')}
                                        clicouVer={() => {
                                            clicouVer(registro.dados.cartaOferta);
                                        }}
                                    />
                                )}
                            </tbody>
                        </table>
                        {/* <PaginacaoComponente
                            pagina={parametros.pagina}
                            registrosPorPagina={parametros.registrosPorPagina}
                            totalRegistros={totalRegistros}
                            alterouPagina={(pagina) => {
                                alterarParametros({...parametros, pagina: pagina});
                            }}
                        /> */}
                        {carregando && 
                            <Carregador className="rounded-bottom" />
                        }
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </>

}